import { render, staticRenderFns } from "./PreviewButton.vue?vue&type=template&id=2148dec9&"
import script from "./PreviewButton.vue?vue&type=script&lang=js&"
export * from "./PreviewButton.vue?vue&type=script&lang=js&"
import style0 from "./PreviewButton.vue?vue&type=style&index=0&id=2148dec9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports